import React from "react";
import {UiButton} from "../../ui-components/button/uiButton";
import {useTranslation} from "react-i18next";


type EditProfilePictureType = {
    profilePictureUrl: string;
    previewProfilePictureUrl: string;
    onEditClick: () => void;
    editMode: boolean;
}

export const EditProfilePicture: React.FC<EditProfilePictureType> = (props) => {
    const {t} = useTranslation();

    return (
        <div className="w-fit relative">
             <div className="rounded-full overflow-hidden w-40 h-40 md:w-60 md:h-60">
                <img
                    className="w-full h-full object-cover"
                    src={props.editMode && props.previewProfilePictureUrl ? props.previewProfilePictureUrl : props.profilePictureUrl}
                    alt={t("account.profile-picture")}
                />
            </div>

            {props.editMode && <UiButton
                className="absolute w-11 h-11 bottom-0 md:bottom-4 right-0 md:right-4"
                icon="edit"
                onClick={props.onEditClick}
            />}
        </div>
    )
}
